import * as types from '../actions/actionTypes';
import initialState from './initialState';


        
        
export default function usuariocursoReducer(state= initialState.usuariocurso, action){
    let newState;
	switch(action.type){
         case types.LOAD_USUARIOCURSO_LIST_SUCCESS:		
            action.usuariocurso.filtroActivo=state.filtroActivo;
            action.usuariocurso.filtroActual=state.filtroActual;
            action.usuariocurso.showActivos=state.showActivos;
			 action.usuariocurso.paginaActual=action.usuariocurso.pageable.pageNumber;
			 action.usuariocurso.registrosPorPagina=action.usuariocurso.size;
            
            return action.usuariocurso;

        case types.BORRAR_USUARIOCURSO_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(usuariocurso => usuariocurso.id !== action.usuariocurso.id)];          
			return newState;    
            
        case types.ACTIVAR_USUARIOCURSO_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(usuariocurso => usuariocurso.id !== action.usuariocurso.id)];          
			 return newState;
            
        case types.SET_FILTRO_USUARIOCURSO:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}